// extracted by mini-css-extract-plugin
export default {"aside":"dashboardOptions_aside__D8R70","options":"dashboardOptions_options__JLRxV"};